import { render } from "./RegisterEndorserModalBibo2.vue?vue&type=template&id=3fd2c9a2"
import script from "./RegisterEndorserModalBibo2.vue?vue&type=script&lang=ts"
export * from "./RegisterEndorserModalBibo2.vue?vue&type=script&lang=ts"
script.render = render

export default script